import React from 'react';

import { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';
import useConfirmPopup from '@/src/components/common/Elements/Modal/useConfirmPopup';

export const useConfirmDeletedEntry = () => {
  return useConfirmPopup({
    // modalWidth: '600px',
    title: (
      <span className="tw-text-cfo-blue-600 tw-font-brandonTextMedium tw-text-[18px] ">
        Entry has been deleted
      </span>
    ),
    message: `Please reload the page to see the latest updates before proceeding`,
    cancelBtn: {
      label: 'Cancel',
    },
    confirmBtn: {
      label: 'Reload the page',
    },
    icon: {
      icon: ICONS.info,
      iconType: ICON_TYPES.outlined,
      className: 'tw-text-cfo-blue-600 tw-text-[22px] tw-font-medium',
    },
  });
};
